import type { SearchValues } from "@/types/flights";
import { size } from "lodash";
import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import { getFlightClassOptions } from "../useSearchFlights";
import FlightClassDropdown from "./FlightClassDropdown";
import { TravellersWithCabinClass } from "./TravellersWithCabinClass";

type Props = {
  className?: string;
  values: SearchValues;
  setValues: Dispatch<SetStateAction<SearchValues>>;
  isFullScreenModal?: boolean;
};

const getTravellers = (
  t: ReturnType<typeof useTranslations>,
  values: SearchValues
) => {
  const travellers =
    size(values.adults) + size(values.children) + size(values.infants);

  return travellers === 1
    ? t("HomePageFlights.oneTraveller")
    : t("HomePageFlights.manyTravellers", { count: travellers });
};

export const FlightClassWithTravellers = ({
  values,
  className,
  setValues,
  isFullScreenModal = false,
}: Props) => {
  const t = useTranslations();

  if (isFullScreenModal) {
    const travellers = getTravellers(t, values);
    const option = getFlightClassOptions(t).find(
      (option) => option.value === values.flightClass
    );
    const valueAsLabel = `${travellers}, ${option?.label}`;

    return (
      <TravellersWithCabinClass
        setValues={setValues}
        valueAsLabel={valueAsLabel}
        className={className}
        isFullScreenModal
        values={values}
      />
    );
  }

  return (
    <>
      <FlightClassDropdown
        value={values.flightClass}
        onChange={(flightClass) => {
          setValues((prev) => ({ ...prev, flightClass }));
        }}
      />
      <TravellersWithCabinClass
        valueAsLabel={getTravellers(t, values)}
        setValues={setValues}
        className={className}
        values={values}
      />
    </>
  );
};
